import { apiCall } from '../../../../../../common/api/api'
import {
  MedidasPorMatriculaRequest,
  MedidasPorMatriculaResponse,
} from '../../../../../../common/types/MedidasPorMatricula'

const baseUrl = `${process.env.GATSBY_API_URL}`

export const apiMedidas = {
  async medidas(
    payload: MedidasPorMatriculaRequest
  ): Promise<MedidasPorMatriculaResponse> {
    return apiCall(`${baseUrl}/medidas-por-matricula`, {
      method: 'POST',
      body: JSON.stringify(payload),
    })
  },
}
